import script from "./FooterCountries.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterCountries.vue?vue&type=script&lang=ts&setup=true"

import "./FooterCountries.vue?vue&type=style&index=0&id=611bead7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611bead7"]])

export default __exports__